import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AuthProvider } from "@descope/react-sdk";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { LicenseInfo } from "@mui/x-license-pro";

import RootErrorBoundary from "./components/errors/RootErrorBoundary";
import AlertSnackbar from "./components/global/components/AlertSnackbar";
import store from "./redux/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import appRoutes from "./routes";
import { lightModeTheme } from "./theme";

// Filter only source map warnings in console
const originalConsoleWarn = console.warn;
console.warn = function(msg) {
	if (msg && typeof msg === "string" && msg.includes("Failed to parse source map")) {
		return;
	}
	originalConsoleWarn.apply(console, arguments);
};

const router = createBrowserRouter(appRoutes);

const root = ReactDOM.createRoot(document.getElementById("root"));

LicenseInfo.setLicenseKey("bda2ff293af5bcc9c3a8a9ec75f32a9dTz0xMjMwNTAsRT0xNzk3MDMzNTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=");

root.render(
	<RootErrorBoundary>
		<AuthProvider projectId={process.env.REACT_APP_DESCOPE_PROJECT_ID}>
			<Provider store={store}>
				<ThemeProvider theme={lightModeTheme}>
					<CssBaseline />
					<AlertSnackbar />
					<RouterProvider router={router}>
						<App />
					</RouterProvider>
				</ThemeProvider>
			</Provider>
		</AuthProvider>
	</RootErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();